<template>
  <div>
    <h2>Your Access is Pending Validation</h2>
    <div>Contact a system administrator to make sure that your access has been approved</div>
  </div>
</template>

<script>

</script>